import { createReducer, on } from '@ngrx/store';
import { ActiveComponentChanged } from 'src/app/shared/actions/eliqua.actions';
import { GetMeToMember } from '../actions/search-checkbooks-actions.actions';
import {
  CardNumberChanged,
  CheckbookCodeChanged,
  ClearCheckbooksFilters,
  GetCheckbooksTypesSuccess,
  GetCouponSetSuccess,
  GivenDateChanged,
  GivenDateCleared,
  GivenStatusChanged,
  InvoiceNumberChanged,
  PanelStatusChanged,
  SelectedTypeChanged,
} from '../actions/search-checkbooks.actions';
import { CheckbooksTypesResponse } from '../models/search-checkbooks.model';

export interface SearchCheckbooksState {
  panelExpanded: boolean;
  checkbooksTypes: CheckbooksTypesResponse[];
  selectedTypeId: number | null;
  cardNumber: string;
  givenDate: Date | null;
  givenDateFormat: string;
  checkbookCode: string;
  invoiceNumber: string | null;
  givenStatus: boolean | null;
  loyaltyMemberId: number | null;
  couponSet: any;
}

const initialState: SearchCheckbooksState = {
  panelExpanded: true,
  checkbooksTypes: [],
  selectedTypeId: null,
  cardNumber: '',
  givenDate: null,
  givenDateFormat: '',
  checkbookCode: '',
  invoiceNumber: null,
  givenStatus: false,
  loyaltyMemberId: null,
  couponSet: [],
};

export const SearchCheckbooksReducer = createReducer(
  initialState,
  on(PanelStatusChanged, (state) => ({
    ...state,
    panelExpanded: !state.panelExpanded,
  })),
  on(GetCheckbooksTypesSuccess, (state, { response }) => {
    const checkbooksTypes = response.map((e) => ({
      tablebookcoupontypeId: e.tablebookcoupontypeId,
      bookCouponType: e.bookCouponType,
    }));
    return {
      ...state,
      checkbooksTypes,
    };
  }),
  on(SelectedTypeChanged, (state, { selectedTypeId }) => ({
    ...state,
    selectedTypeId,
  })),
  on(CardNumberChanged, (state, { cardNumber }) => ({
    ...state,
    cardNumber,
  })),
  on(GivenDateChanged, (state, { givenDate, givenDateFormat }) => ({
    ...state,
    givenDate,
    givenDateFormat,
  })),
  on(GivenDateCleared, (state) => ({
    ...state,
    givenDate: null,
    givenDateFormat: '',
  })),
  on(CheckbookCodeChanged, (state, { checkbookCode }) => ({
    ...state,
    checkbookCode,
  })),
  on(InvoiceNumberChanged, (state, { invoiceNumber }) => ({
    ...state,
    invoiceNumber,
  })),
  on(GivenStatusChanged, (state, { givenStatus }) => ({
    ...state,
    givenStatus,
    cardNumber: givenStatus ? state.cardNumber : '',
    givenDate: givenStatus ? state.givenDate : null,
    givenDateFormat: givenStatus ? state.givenDateFormat : '',
  })),
  on(ClearCheckbooksFilters, (state) => ({
    ...state,
    panelExpanded: true,
    selectedTypeId: null,
    cardNumber: '',
    givenDate: null,
    givenDateFormat: '',
    checkbookCode: '',
    invoiceNumber: null,
    givenStatus: false,
    loyaltyMemberId: null,
  })),
  on(GetMeToMember, (state, { loyaltyMemberId }) => ({
    ...state,
    loyaltyMemberId,
  })),
  on(ActiveComponentChanged, (state) => ({
    ...state,
    panelExpanded: true,
    selectedTypeId: null,
    cardNumber: '',
    givenDate: null,
    givenDateFormat: '',
    checkbookCode: '',
    invoiceNumber: null,
    givenStatus: false,
    loyaltyMemberId: null,
  })),
  on(GetCouponSetSuccess, (state, { response }) => ({
    ...state,
    couponSet: response,
  })),
);
